import React, { useState } from "react";
import { pdf } from "@react-pdf/renderer";
import TranscriptPDF from "./TranscriptPDF";

import DefaultButton from "../../components/simple/DefaultButton";

const TranscriptShare = ({ transcriptData, user, avatarPersona, isMobile, theme }) => {
  const [isGenerating, setIsGenerating] = useState(false);

  // Helper: Generates the Blob from the React component
  const generatePdfBlob = async () => {
    const blob = await pdf(
      <TranscriptPDF user={user} data={transcriptData} avatarPersona={avatarPersona} />
    ).toBlob();
    return blob;
  };

  const handleNativeShare = async () => {
    setIsGenerating(true);
    try {
      const blob = await generatePdfBlob();
      const file = new File([blob], "simulation-transcript.pdf", {
        type: "application/pdf",
      });

      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
          files: [file],
          title: "Simulation Transcript",
          text: "Here is the transcript from my recent simulation.",
        });
      } else {
        alert("Sharing is not supported on this browser. Downloading instead.");
        handleDownload(); // Fallback
      }
    } catch (error) {
      console.error("Error sharing:", error);
    } finally {
      setIsGenerating(false);
    }
  };

  const handleDownload = async () => {
    setIsGenerating(true);
    try {
      const blob = await generatePdfBlob();
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `transcript-${
        new Date().toISOString().split("T")[0]
      }.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } finally {
      setIsGenerating(false);
    }
  };

  const handleEmail = async () => {
    // Note: 'mailto' cannot attach files directly due to security restrictions.
    // Best Practice: Download the file, then open the mail client.
    await handleDownload();

    const subject = encodeURIComponent("Simulation Transcript");
    const body = encodeURIComponent(
      "I have downloaded the simulation transcript. Please find it attached."
    );
    window.location.href = `mailto:?subject=${subject}&body=${body}`;
  };

  const ShareIcon = (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 10V13.5C17.5 14.9001 17.5 15.6002 17.2275 16.135C16.9878 16.6054 16.6054 16.9878 16.135 17.2275C15.6002 17.5 14.9001 17.5 13.5 17.5H6.5C5.09987 17.5 4.3998 17.5 3.86502 17.2275C3.39462 16.9878 3.01217 16.6054 2.77248 16.135C2.5 15.6002 2.5 14.9001 2.5 13.5V10M13.3333 5.83333L10 2.5M10 2.5L6.66667 5.83333M10 2.5V12.5"
        stroke="#FEFEFE"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const DownloadIcon = (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 2v7m0 0l-3-3m3 3l3-3"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 11v2c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-2"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      Download PDF
    </>
  );
  return (
    <div className="transcript-share">
      {/* Mobile / Generic Share Button */}

      {isMobile ? (
        <DefaultButton
          onClick={handleNativeShare}
          disabled={isGenerating}
          backgroundColor="transparent"
          textColor={theme.palette.text.primary}
          borderColor={theme.palette.border?.brand}
          wideOnMobile
        >
          {isGenerating ? "Generating..." : ShareIcon}
        </DefaultButton>
      ) : (
        <DefaultButton
          onClick={handleDownload}
          disabled={isGenerating}
          backgroundColor="transparent"
          textColor={theme.palette.text.primary}
          borderColor={theme.palette.border?.brand}
          wideOnMobile
        >
          {isGenerating ? "Generating..." : DownloadIcon}
        </DefaultButton>
      )}

      {/* Desktop Email */}
      {/* <button
        onClick={handleEmail}
        disabled={isGenerating}
        className="p-2 border border-gray-300 rounded hover:bg-gray-50 flex items-center gap-2"
      >
        Share via Email
      </button> */}
    </div>
  );
};

export default TranscriptShare;
